export const getRandomCopyVariation = (copyVariations: string[]) => {
  const randomIndex = Math.floor(Math.random() * copyVariations.length)
  return copyVariations[randomIndex]
}
